import { IMAGE_COMPRESSOR } from '../../../utils/imageCompressor';

export const capitalize = (str) => {
  if (!str) return '';
  return str
    .replaceAll("_", " ")
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
export const formatDescription = (desc) => {
  return desc || '';
};

export const getImageUrl = (item, itemType) => {
  if (itemType === "EXT") {
    return item?.closeUpURL;
  } else {
    return item?.focus_image_url ? 
      IMAGE_COMPRESSOR({ url: item?.focus_image_url }) : 
      item?.closeUpURL;
  }
}; 